import { BehaviorSubject, Observable } from 'rxjs';
import { notifyMessage } from '../../../../shared/constants/notify-message';
import { Alert, AlertData } from './alert';

export enum QuotaNestingAlert {
  MORE_QUOTAS_THAN_COMPLETES = 'more-quotas-than-completes',
}

export const DEFAULT_ALERTS: Record<QuotaNestingAlert, Alert> = {
  [QuotaNestingAlert.MORE_QUOTAS_THAN_COMPLETES]: Alert.error(
    notifyMessage.errorMessage.MULTI_QUOTA_NESTING.MORE_QUOTAS_THAN_COMPLETES
  ),
};

export class QuotaNestingAlertManager {
  private readonly _alerts = DEFAULT_ALERTS;
  private readonly _alerts$ = new BehaviorSubject<AlertData[]>(
    this.alertsData()
  );

  public get alerts(): AlertData[] {
    return this.alertsData();
  }

  public get alerts$(): Observable<AlertData[]> {
    return this._alerts$.asObservable();
  }

  public setVisibility(name: QuotaNestingAlert, visible: boolean) {
    this._alerts[name] = this._alerts[name].setVisibility(visible);
    this._alerts$.next(this.alertsData());
  }

  private alertsData(): AlertData[] {
    return Object.values(DEFAULT_ALERTS).map((alert) => alert.data());
  }
}
